
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import AppLoadingButton from "@/components/mui/LoadingButton";
import { GUIDE_STEPS, KYC_STATUS, MAX_WIDTH } from "@/constant/Constant.ts";
import RouteConstant from "@/constant/RouteConstant.js";
import { getHomeInfo, getToken, getUserInfo, onUserLogout } from "@/redux/slices/user.js";
import { dispatch } from "@/redux/store.js";
import { getUserCurrentGuideStep, isUserCompleteGuide } from "@/utils/userUtils";
import {
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  styled,
  Box,
  Typography,
  useTheme,
  Stack,
  Badge, Drawer, Divider,
  StepConnector,
  stepClasses,
  stepLabelClasses,
  stepConnectorClasses,
  alpha
} from "@mui/material";
// import GuideBindMobile from "./guide/bindmobile/GuideBindMobile";
// import GuideBuyCard from "./guide/buycard/GuideBuyCard";
// import GuideDeposit from "./guide/deposit/GuideDeposit";
// import GuideKYC from "./guide/kyc/GuideKYC";
import RpIcon from "@/components/RpIcon";
import LogoHeader from "./components/Headers/LogoHeader";
import { useConfirm } from "material-ui-confirm";
import { logout } from "@/services/user";
import { enqueueSnackbar } from "notistack";
import useWindowSize from "@/hook/useWindowSize";
import UserAvatar from "@/pages/components/UserAvatar";
import classes from "@/pages/components/MobileAccountInfo/index.module.less";
import CopyButton from "@/components/CopyButton";
import KYCCard from "@/pages/kyc/components/KYCCard.tsx";
import { onToggleAccountDrawerOpen, onToggleWalletDrawerOpen } from "@/redux/slices/app";
import { setAmountVisible, setWithdrawInfo } from "@/redux/slices/assets";
import AmountDisplay from "@/components/AmountDisplay";
import UserAssets from "@/components/UserAssets";
import { useBoolean } from "ahooks";
import VarietySelectModal from "@/pages/components/VarietySelectModal";
import MobileLanguageSelector from "@/pages/components/MobileLanguageSelector";
// import { info } from "@/theme/colors";
import useIntercom from "@/hook/useIntercom";

const StyledWrapper = styled(Box)(({ theme, width }) => {

  return {
    minHeight: '100vh',
    width: '100%',
    background: 'url(/images/sonic/sonic-home-bg.png) no-repeat',
    backgroundSize: '100% auto',
    backgroundPositionY: "-30%",

  }
})

const StyledShadowCard = styled('div')(({ theme }) => ({
  borderRadius: '12px',
  padding: '20px 24px',
  background: 'rgba(37, 39, 39, 0.90)',
  boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.10)',
  backdropFilter: 'blur(4px)',
  // marginTop: '260px',
  '.title': {
    fontSize: '18px',
    fontWeight: 700,
  },
  '.subtitle': {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.text.secondary,
    padding: '6px 0',
  },
  '.MuiStepIcon-root': {
    '&.Mui-active': {
      color: `${theme.palette.brand.main} !important`,
    },
    '&.Mui-completed': {
      color: `${theme.palette.brand.main} !important`,
    }
  }
}))

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.brand.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.brand.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: alpha(theme.palette.text.primary, 0.05),
    borderTopWidth: 1,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      borderColor: theme.palette.grey[800],
    }),
  },
}));

const TIMELINE = [
  GUIDE_STEPS.STEP_BIND_MOBILE,
  GUIDE_STEPS.STEP_KYC,
  // GUIDE_STEPS.STEP_DEPOST,
  GUIDE_STEPS.STEP_BUY_CARD,
]


export default function Home() {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(GUIDE_STEPS.STEP_BIND_MOBILE);
  const confirm = useConfirm();
  const { accountDrawerOpen, walletDrawerOpen } = useSelector((state) => state.app);
  const { user, loading, homeInfo, zendeskUnreadMessageCount, unreadMessageCount } = useSelector((state) => state.user);
  const { amountVisible } = useSelector((state) => state.assets);
  const { width } = useWindowSize();

  const [varietyOperate, setVarietyOperate] = useState('')

  const [varietySelectModalOpen, varietySelectModalOpenOperate] = useBoolean(false);
  const [isLanguageSelectorOpen, languageSelectorOperate] = useBoolean(false);
  const [selectedVariety, setSelectedVariety] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const {showIntercom} = useIntercom()

  const onVarietySelected = (variety) => {
    setSelectedVariety(variety)

    if (varietyOperate === 'deposit')
      navigate(`${RouteConstant.USER_DEPOSIT}?variety_code=${variety.varietyCode}`)
    if (varietyOperate === 'withdraw')
      navigate(`${RouteConstant.USER_WITHDRAW}?variety_code=${variety.varietyCode}`)
  }
  const getActiveStep = (user) => {
    if(user?.mobileStatus == 0){
      return 0 
    }
    if (user?.kycStatus == 0 || user?.kycStatus == 2 || user?.kycStatus == 1) {
      return 1
    }
    return 0
  }

  useEffect(() => {
    if (!getToken()) {
      navigate(RouteConstant.LOGIN);
      return;
    }

    if (!user) {
      dispatch(getUserInfo());
    } else {
      if (isUserCompleteGuide(user)) {
        navigate(RouteConstant.MAIN);
        return;
      }
      setCurrentStep(getUserCurrentGuideStep(user));
      const step = getActiveStep(user)
      setActiveStep(step)
    }
  }, [user]);

  const _isStepComplete = (step) => {
    return step < currentStep;
  }

  const _getStepLabel = (step) => {
    if (step == GUIDE_STEPS.STEP_BIND_MOBILE) {
      return t('bind_your_mobile_number');
    } else if (step == GUIDE_STEPS.STEP_KYC) {
      return t('complete_identity_verification');
    }
    // else if (step == GUIDE_STEPS.STEP_DEPOST) {
    //   return t('deposit');
    // } 
    else if (step == GUIDE_STEPS.STEP_BUY_CARD) {
      return t('apply_a_virtual_or_physical_card');
    }
  }

  const _getStepContent = (step) => {
    if (step == GUIDE_STEPS.STEP_BIND_MOBILE) {
      if (user?.mobileBindStatus == 1) {
        return <Stack direction={'row'} alignItems={'center'} style={{ color: theme.palette.success.main }}>
          <RpIcon icon={'check-circle-thin'} size={18} />
          <Typography fontSize={'10px'} color={theme.palette.success.main}>{`${t('bound')} (${user.mobile})`}</Typography>
        </Stack>
      } else {
        return null;
      }
    } else if (step == GUIDE_STEPS.STEP_KYC) {
      if (!user) {
        return null
      } else {
        if (user.kycStatus == KYC_STATUS.KYC_STATUS_NOT_SUBMIT) {
          return null
        }
        let _sx = {
          color: theme.palette.text.primary
        }
        if (user.kycStatus == KYC_STATUS.KYC_STATUS_SUBMITTED) {
          _sx = {
            color: theme.palette.warning.main
          }
        }
        if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) {
          _sx = {
            color: theme.palette.success.main
          }
        }
        return (
          <>
            <Stack
              sx={_sx}
              direction="row" alignItems="center" gap={'6px'}>
              {_getStepIcon(user)}
              {
                _getStepStatusDisplay(user)
              }
            </Stack>
            {_getStepStatusTip(user)}
          </>
        )
      }
    } 
    return null;
  }
  const _getStepIcon = (user) => {
    // return <RpIcon color={theme.palette.warning.main} icon={'info'} size={18} />
    if (user.kycAmlReject == 1 && !user.kycAmlDeclareSubmit) {
      return <RpIcon color={theme.palette.warning.main} icon={'info'} size={18} />
    }
    if (user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED) {
      return <RpIcon color={theme.palette.success.main} icon={'check-circle-thin'} size={18} />
    }
    if (user.kycStatus == KYC_STATUS.KYC_STATUS_SUBMITTED) {
      return <RpIcon color={theme.palette.warning.main} icon={'check-circle-thin'} size={18} />
    }
    return null;
  }
  const _getStepStatusDisplay = (user) => {
    if (user.kycAmlReject == 1 && !user.kycAmlDeclareSubmit) {
      return <Typography sx={{
        fontSize: '12px'
      }}>{t(`additional_info_request`)}</Typography>
    }
    return<>
      <Typography sx={{
        fontSize: '12px'
      }}>{t(`kyc_status_${user?.kycStatus}`)}</Typography>
      {user.kycStatus == KYC_STATUS.KYC_STATUS_SUBMITTED && <RpIcon
          clickable
          onClick={() => {
            dispatch(getUserInfo());
          }}
      icon="refresh" size={12} />}
    </> 
  }
  const _getStepStatusTip = (user) => {
    if (user.kycAmlReject == 1 &&!user.kycAmlDeclareSubmit) {
      return null
    }
    if(user.kycStatus != KYC_STATUS.KYC_STATUS_APPROVED){
      return <Typography sx={{
        fontSize: '12px'
      }}>{t('review_takes_time')}</Typography>
    }
    return null;
  }

  const _onContinue = () => {
    if (currentStep == GUIDE_STEPS.STEP_BIND_MOBILE) {
      // navigate(RouteConstant.GUIDE_BIND_MOBILE);
      navigate(RouteConstant.USER_SECURITY_MOBILE);
    } else if (currentStep == GUIDE_STEPS.STEP_KYC) {
      // navigate(RouteConstant.GUIDE_KYC);
      if (user.hasSubmitKycPreInfo != 1) {
        navigate(RouteConstant.KYC_PRE_FORM);
      } else {
        navigate(RouteConstant.KYC_MAIN);
      }
    } else if (currentStep == GUIDE_STEPS.STEP_DEPOST) {
      navigate(RouteConstant.GUIDE_DEPOSIT);
    } else if (currentStep == GUIDE_STEPS.STEP_BUY_CARD) {
      navigate(RouteConstant.CARD_APPLY);
    }
  }

  const _onLogout = () => {
    confirm({
      description: t('logout_confirm'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doLogout();
    });
  }

  const _doLogout = async () => {
    try {
      await logout();
      dispatch(onUserLogout());

      enqueueSnackbar(t("log_out_toast"), { variant: "success" });
      navigate(RouteConstant.LOGIN, { replace: true });
    } catch (e) {
      console.error(e);
    }
  }

  const _onToggleAccountDrawerOpen = () => {
    dispatch(onToggleAccountDrawerOpen());
  }

  const _onToggleWalletDrawerOpen = () => {
    dispatch(onToggleWalletDrawerOpen());
  }

  const _onDeposit = () => {
    // navigate(RouteConstant.DEPOSIT_VARIETY_SELECT);
    // walletDrawerOpenOperate.setFalse()
    setVarietyOperate('deposit')
    varietySelectModalOpenOperate.setTrue()
  }

  const _onWithdraw = () => {
    setVarietyOperate('withdraw')
    dispatch(setWithdrawInfo({
      address: '',
      amount: '',
      network: null,
    }))
    // navigate(RouteConstant.WITHFRAW_VARIETY_SELECT);
    // walletDrawerOpenOperate.setFalse()
    varietySelectModalOpenOperate.setTrue()
  }

  const onLogout = async () => {
    confirm({
      description: t('logout_confirm'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doLogout();
    });
  };

  if (!user) {
    return null;
  }

  return <>
    <StyledWrapper width={width}>
      <LogoHeader leading={
        user.mobileStatus == 1 ? <Box onClick={() => {
          _onToggleAccountDrawerOpen()
        }}>
          <UserAvatar size={30} fontSize={24} nationSize={18} />
        </Box> : <RpIcon icon={'log_out'} onClick={_onLogout} clickable size={22} />
      }
        right={
          user.kycStatus == KYC_STATUS.KYC_STATUS_APPROVED ?
            <Stack
              sx={{
                border: `1px solid ${theme.palette.background.paper}`,
                padding: '4px 8px',
                borderRadius: '24px',
                position: 'absolute',
                right: 8,
                cursor:"pointer"
              }}
              direction="row" alignItems="center" variant="contained" onClick={() => {
                dispatch(getHomeInfo());
                _onToggleWalletDrawerOpen()
              }}>
              <RpIcon icon={'eWallet'} size={18} />
              <Typography sx={{ marginLeft: '8px' }}>{t('wallet')}</Typography>
            </Stack> : <RpIcon icon="" />
        }
      />
      <Box sx={{ padding: '24px' ,margin:"30px 0 40px"}}>
        <img style={{ display: "block", width: "70%", borderRadius: "12px",transform:'rotate(-15deg) translateX(10px)',margin:"0 auto" }} src="/images/sonic/sonic-card.png" alt="" />
      </Box>
      <Box sx={{ padding: '16px' }}>
        <StyledShadowCard>
          <div className="title">{t('get_your_redotpay_card_in_steps')}</div>
          <div className="subtitle">{t('get_your_redotpay_card_subtitle')}</div>

          <Stepper activeStep={activeStep} orientation="vertical"
            connector={<QontoConnector />}
            style={{ paddingTop: '16px', paddingBottom: '24px' }}>
            {TIMELINE.map((step, index) => {
              const stepProps: { completed?: boolean, index?: number } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              if (_isStepComplete(step)) {
                stepProps.completed = true;
              }
              const label = _getStepLabel(step);
              return (
                <Step key={label} {...stepProps} >
                  <StepLabel {...labelProps}>
                    {/* <StepIcon content={index + 1} activeStep={activeStep} index={index} /> */}
                    {label}
                    <Box>{_getStepContent(step)}</Box>
                  </StepLabel>

                </Step>
              );
            })}
          </Stepper>

          <Button
            style={{
              borderRadius: '32px',
            }}
            variant="contained"
            size="large"
            fullWidth
            onClick={() => _onContinue()}
          >
            {t("continue_key")}
          </Button>
        </StyledShadowCard>
      </Box>

    </StyledWrapper>
    <Drawer
      open={accountDrawerOpen}
      onClose={_onToggleAccountDrawerOpen}
      anchor="left"
    >
      <Box className={classes["drawer-account-wrap"]}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" className={classes.header}>
          <Box onClick={_onToggleAccountDrawerOpen}><RpIcon icon="arrow-left" size={22} /></Box>
          <Stack direction="row" gap={3}>
           
            <Box onClick={() => { navigate(RouteConstant.MESSAGE_LIST) }}>
              <Badge color="error" variant="dot" invisible={!unreadMessageCount}>
                <RpIcon icon="bell" size={22} />
              </Badge>
            </Box>
          </Stack>
        </Stack>
        <Stack className={classes["userInfo-wrap"]} direction="row">
          <Box>
            <UserAvatar size={48} fontSize={24} nationSize={18} />
          </Box>

          <Box>
            <p className={classes['account']}>{user?.email}</p>
            <Stack direction="row" alignItems={'center'} gap={0.5}>
              <p className='span'>ID: {user?.uid}</p>
              <CopyButton color={""} value={user?.uid} size={12} />
            </Stack>
            <Box className={classes['kyc-status']}><KYCCard /></Box>
          </Box>
        </Stack>
        <Stack
          direction="row"
          justifyContent={'space-between'}
          alignItems="center"
          className={classes['account-center-list']}
          onClick={() => { navigate(RouteConstant.USER_SECURITY) }}
        >
          <Stack direction="row" gap={'12px'}>
            <RpIcon icon="safe" size={22} />
            {/*<SecurityCard/>*/}
            {t('security')}
          </Stack>
          <RpIcon icon="arrow-right-simple" size={18} />
        </Stack>

        <Stack
          direction="row"
          onClick={() => { showIntercom() }}
          justifyContent={'space-between'}
          alignItems="center"
          className={classes['account-center-list']}
        >
          <Stack direction="row" gap={'12px'}>
            <RpIcon icon="help" size={22} />
            <p>{t('support_center')}</p>
          </Stack>
          <RpIcon icon="arrow-right-simple" size={18} />
        </Stack>

        <Stack
          direction="row"
          onClick={() => { languageSelectorOperate.setTrue() }}
          justifyContent={'space-between'}
          alignItems="center"
          className={classes['account-center-list']}
        >
          <Stack direction="row" gap={'12px'}>
            <RpIcon icon="lang" size={22} />
            <p>{t('language')}</p>
          </Stack>
          <RpIcon icon="arrow-right-simple" size={18} />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent={'space-between'}
          className={classes['account-center-list']}
          onClick={onLogout}
        >
          <Stack direction="row" gap={'12px'}>
            <RpIcon icon="log_out" size={22} />
            <p>{t('logout')}</p>
          </Stack>
          <RpIcon icon="arrow-right-simple" size={18} />
        </Stack>
      </Box>
    </Drawer>
    <Drawer
      open={walletDrawerOpen}
      onClose={_onToggleWalletDrawerOpen}
      anchor="right">
      <Stack
        sx={theme => {
          return {
            minWidth: '300px',
            minHeight: '100%',
          }
        }}
      >
        <Stack>
          <Box className={'container-wrap'}>
            <Stack direction="row" justifyContent="space-between">
              <RpIcon icon="arrow-left"
                clickable
                onClick={() => {
                  _onToggleWalletDrawerOpen()
                }}
                size={24} />
              <RpIcon icon="file"
                clickable
                onClick={() => {
                  navigate(RouteConstant.ASSETS_TRANS_LIST);
                }}
                size={24} />
            </Stack>
            <Stack direction="row" alignItems={'center'} gap={'10px'} sx={{ marginTop: '26px' }}>
              <Box className={'small'}>{t('total_balance')}</Box>
              <RpIcon size={22} icon={amountVisible ? 'eye_open' : 'eye_close'} clickable
                onClick={() => {
                  dispatch(setAmountVisible(!amountVisible))
                }}
              />
            </Stack>
            <Stack className={'text-primary-bold'} direction={'row'} alignItems={'flex-end'} spacing={1} alignContent={'center'}>
              <AmountDisplay
                fontSize={'32px'}
                fontWeight={700}
                visible={amountVisible as Boolean} amount={`${homeInfo?.assetUser.available}`} />
              <Typography fontSize={'32px'} fontWeight={700}>{homeInfo?.assetUser.currencyCode}</Typography>
            </Stack>
            <Stack
              direction="row" gap="18px"
              sx={({
                marginTop: '20px',
                '& > button': {
                  borderRadius: '16px',
                  flex: 1
                }
              })}>
              <Button
                sx={theme => ({
                  backgroundColor: theme.palette.background.avatar,
                  color: theme.palette.primary.contrastText,
                  borderRadius: '32px!important',
                  padding: '8px 0',
                  fontSize: '13px'
                })}
                variant="contained" size="small" onClick={_onDeposit}>
                <Stack direction={'row'} gap={'6px'} alignItems={'center'}>
                  <span className={'icon-deposit'}><RpIcon icon="plus_sign" size={14} /></span>
                  <span>{t("deposit")}</span>
                </Stack>
              </Button>
              <Button
                sx={theme => ({
                  backgroundColor: theme.palette.background.card,
                  color: theme.palette.text.primary,
                  borderRadius: '32px!important',
                  padding: '8px 0',
                  fontSize: '13px'
                })}
                size="small" onClick={_onWithdraw}>
                <Stack direction={'row'} gap={'6px'} alignItems={'center'}>
                  <RpIcon icon="minus_sign" size={18} />&nbsp;
                  <span>{t("withdraw")}</span>
                </Stack>
              </Button>
            </Stack>
          </Box>
          <Divider sx={{ margin: '8px 0', borderColor: theme.palette.borderColor?.divider, borderWidth: '0.5px' }} />
          <Box className={'container-wrap'}>
            <UserAssets amountVisible={amountVisible} list={homeInfo?.assetUser?.accountList} />
          </Box>
        </Stack>
      </Stack>
    </Drawer>
    <VarietySelectModal open={varietySelectModalOpen}
      varietyOperate={varietyOperate}
      onClose={varietySelectModalOpenOperate.setFalse}
      onSelected={onVarietySelected}
    />
    <MobileLanguageSelector
      open={isLanguageSelectorOpen}
      onClose={languageSelectorOperate.setFalse}
    />
  </>
}